import { render, staticRenderFns } from "./phase-item.vue?vue&type=template&id=37d1b926&scoped=true"
import script from "./phase-item.vue?vue&type=script&lang=js"
export * from "./phase-item.vue?vue&type=script&lang=js"
import style0 from "./phase-item.vue?vue&type=style&index=0&id=37d1b926&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d1b926",
  null
  
)

export default component.exports